import React from "react";
import { observer } from "mobx-react";
import { Typography, Input } from "antd";
import moment from "moment";
import { observable } from "mobx";
import { TemplateModel } from "../../../../stores/TemplateModel";
import { withRouter, RouteComponentProps } from "react-router-dom";
import utils from "../../../../utils";
import PreviewTemplateAction from "../PreviewTemplateAction/PreviewTemplateAction";
import DuplicateTemplateAction from "../DuplicateTemplateAction/DuplicateTemplateAction";
import DeleteTemplateAction from "../DeleteTemplateAction/DeleteTemplateAction";
import EditTemplateAction from "../EditTemplateAction/EditTemplateAction";

interface Props extends RouteComponentProps<any> {
  template: TemplateModel;
  onLoading: (isLoading: boolean) => void;
}

@observer
class CardTemplateActions extends React.PureComponent<Props, any> {
  @observable editMode: boolean = false;

  handleNameChange = (name: string) => {
    this.props.template.name = name;
    this.props.template.save();
  };

  

  handleNameChangeDebounce = utils.debounce(this.handleNameChange);

  render() {
    const { template } = this.props;
    const { Title } = Typography;

    return (
      <div>
        <div>
          <Title level={4}>
            {this.editMode ? (
              <Input
                placeholder="Basic usage"
                defaultValue={template.name}
                size="small"
                onChange={(event: any) =>
                  this.handleNameChangeDebounce(event.target.value)
                }
                onBlur={() => (this.editMode = false)}
              />
            ) : (
              <div onClick={() => (this.editMode = true)}>{template.name}</div>
            )}
          </Title>
          <div>
            Saved: {moment(template.updatedAt || "").format("Do MMMM, YYYY")}
          </div>
        </div>
        <div>
          <PreviewTemplateAction template={template} />
          {!template.isExample() && (
            <EditTemplateAction template={template} />
          )}
          <DuplicateTemplateAction template={template} onLoading={this.props.onLoading}/>

          {!template.isExample() && (
            <DeleteTemplateAction template={template} onLoading={this.props.onLoading}/>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(CardTemplateActions);
